import { Instance, types } from "mobx-state-tree"

// From rpc_schemas.VehicleStateSchema
export interface VehicleStateUpdate {
    id: number, 
    is_connected: boolean,
    is_in_service: boolean,
    is_parked: boolean,
    simulation_status: boolean | null
}


export enum VehicleStatus {
    Online = 'online',
    Offline = 'offline',
    OutOfService = 'outOfService',
}

// The status shown and changed in the vehicles table. A parked vehicle is shown as parked, whether it's in service or not.
export enum VehicleServiceStatus {
    InService = 'inService',
    Parked = 'parked',
    OutOfService = 'outOfService',
}

// The vehicle state that setting each service status sets
export const serviceStatusToVehicleState: Record<VehicleServiceStatus, Pick<VehicleStateUpdate, 'is_in_service' | 'is_parked'>> = {
    [VehicleServiceStatus.InService]: { is_in_service: true, is_parked: false },
    [VehicleServiceStatus.Parked]: { is_in_service: true, is_parked: true },
    [VehicleServiceStatus.OutOfService]: { is_in_service: false, is_parked: false },
}

export const VehicleStateModel = types.model('VehicleStateModel') 
.props({
    is_connected: types.boolean,
    is_in_service: types.boolean,
    is_parked: types.boolean,
    simulation_status: types.maybeNull(types.boolean),
})
.views((self) => ({
    get combinedState() {
        if (!self.is_in_service) 
            return VehicleStatus.OutOfService
        return self.is_connected ? VehicleStatus.Online : VehicleStatus.Offline
    },
    get isParked(): boolean {
        return self.is_parked
    },
    get isInService(): boolean {
        return self.is_in_service
    },
    get serviceStatus(): VehicleServiceStatus {
        if (self.is_parked)
            return VehicleServiceStatus.Parked
        return self.is_in_service ? VehicleServiceStatus.InService : VehicleServiceStatus.OutOfService
    },
}))

export type VehicleState = Instance<typeof VehicleStateModel>